import React, { lazy } from 'react';
import { HomeIcon, PersonIcon } from 'components/Icons/Icons';
import {
  MdChecklist,
  MdPeopleOutline,
  MdInsertChart,
  MdComment,
  MdLibraryBooks,
  MdAutoMode,
  MdPlaylistAdd,
  MdMenuBook,
} from 'react-icons/md';
import { FaGoogle, FaTiktok, FaFacebook, FaYoutube, FaPinterest, FaUsers } from 'react-icons/fa';
import { FaXTwitter, FaThreads } from 'react-icons/fa6';
import { FaFacebookMessenger } from 'react-icons/fa';
import { FaMapMarkerAlt, FaShippingFast, FaRegImage, FaTelegramPlane } from 'react-icons/fa';
import { FaInstagram } from 'react-icons/fa';
import { BiFoodMenu, BiSolidBookContent } from 'react-icons/bi';
import { Roles } from 'constants/common';
import { IoIosLink, IoMdSettings } from 'react-icons/io';
import { FiShield } from 'react-icons/fi';
import { SiScrapbox, SiTelegraph } from 'react-icons/si';
import { FaRegEdit, FaPenNib } from 'react-icons/fa';
import { CgWebsite } from 'react-icons/cg';

// Route-level code splitting: view components are lazy-loaded so they land in
// separate chunks instead of the main bundle. Rendered inside a <Suspense>
// boundary in each layout (Admin/Auth/RTL).
const Dashboard = lazy(() => import('views/Dashboard/Dashboard.js'));
const SignUp = lazy(() => import('views/Pages/SignUp.js'));
const SignIn = lazy(() => import('views/Pages/SignIn'));
const Profile = lazy(() => import('views/Dashboard/Profile'));
const Admin = lazy(() => import('views/Dashboard/Admin'));
const GoogleAcount = lazy(() => import('views/Dashboard/GoogleAcount/GoogleAcount'));
const InstagramAccount = lazy(() => import('views/Dashboard/InstagramAccount/InstagramAccount'));
const YoutubeAccount = lazy(() => import('views/Dashboard/YoutubeAccount/YoutubeAccount'));
const YoutubeAccountForm = lazy(() =>
  import('views/Dashboard/YoutubeAccount/components/YoutubeAccountForm')
);
const YoutubeAccountVideos = lazy(() => import('views/Dashboard/YoutubeAccount/Videos'));
const YoutubeScheduledShares = lazy(() => import('views/Dashboard/YoutubeAccount/ScheduledShares'));
const GoogleAccountForm = lazy(() =>
  import('views/Dashboard/GoogleAcount/components/GoogleAccountForm')
);
const FacebookAcount = lazy(() => import('views/Dashboard/FacebookAccount/FacebookAcount'));
const InstagramAccountForm = lazy(() =>
  import('views/Dashboard/InstagramAccount/components/InstagramAccountForm')
);
const InstagramAccountDetail = lazy(() =>
  import('views/Dashboard/InstagramAccount/components/AccountDetail')
);
const Threads = lazy(() => import('views/Dashboard/Threads/Threads'));
const ThreadsForm = lazy(() => import('views/Dashboard/Threads/components/ThreadsForm'));
const ThreadsAccountDetail = lazy(() => import('views/Dashboard/Threads/components/AccountDetail'));
const ThreadsAccountPosts = lazy(() => import('views/Dashboard/Threads/Posts'));
const ThreadsPost = lazy(() => import('views/Dashboard/ThreadsPost/ThreadsPost'));
const ThreadsPostForm = lazy(() => import('views/Dashboard/ThreadsPost/components/ThreadsPostForm'));
const Comments = lazy(() => import('views/Dashboard/Comments/Comments'));
const CommentForm = lazy(() => import('views/Dashboard/Comments/components/CommentForm'));
const CommentDetail = lazy(() => import('views/Dashboard/Comments/CommentDetail'));
const CommentsBulk = lazy(() => import('views/Dashboard/CommentsBulk/CommentsBulk'));
const CommentTemplates = lazy(() => import('views/Dashboard/CommentTemplates/CommentTemplates'));
const AutoCommentRules = lazy(() => import('views/Dashboard/AutoCommentRules/AutoCommentRules'));
const FacebookForm = lazy(() => import('views/Dashboard/FacebookAccount/components/FacebookForm'));
const FacebookPost = lazy(() => import('views/Dashboard/FacebookPost/FacebookPost'));
const FacebookPostForm = lazy(() =>
  import('views/Dashboard/FacebookPost/components/FacebookPostForm')
);
const FacebookPageFeed = lazy(() => import('views/Dashboard/FacebookPageFeed/FacebookPageFeed'));
const FacebookPageList = lazy(() => import('views/Dashboard/FacebookAccount/PageList'));
const FacebookPagePosts = lazy(() => import('views/Dashboard/FacebookPageFeed/PagePosts'));
const Messenger = lazy(() => import('views/Dashboard/Messenger/Messenger'));
const ScrapboxPost = lazy(() => import('views/Dashboard/ScrapboxPost/ScrapboxPost'));
const ScrapboxPostForm = lazy(() =>
  import('views/Dashboard/ScrapboxPost/components/ScrapboxPostForm')
);
const TelegraphAccount = lazy(() => import('views/Dashboard/TelegraphAccount/TelegraphAccount'));
const TelegraphPost = lazy(() => import('views/Dashboard/TelegraphPost/TelegraphPost'));
const TelegraphPostForm = lazy(() =>
  import('views/Dashboard/TelegraphPost/components/TelegraphPostForm')
);
const TitkokAccount = lazy(() => import('views/Dashboard/TitkokAccount/TitkokAccount'));
const TiktokAccountForm = lazy(() =>
  import('views/Dashboard/TitkokAccount/components/TiktokAccountForm')
);
const TiktokAccountVideos = lazy(() => import('views/Dashboard/TitkokAccount/Videos'));
const TiktokAccountDetail = lazy(() =>
  import('views/Dashboard/TitkokAccount/components/AccountDetail')
);
const TiktokPost = lazy(() => import('views/Dashboard/TiktokPost/TiktokPost'));
const TiktokPostForm = lazy(() => import('views/Dashboard/TiktokPost/components/TiktokPostForm'));
const PinterestAcount = lazy(() => import('views/Dashboard/Pinterest/PinterestAcount'));
const PinterestForm = lazy(() => import('views/Dashboard/Pinterest/components/PinterestForm'));
const PinterestDetail = lazy(() => import('views/Dashboard/Pinterest/PinterestDetail'));
const PinterestPost = lazy(() => import('views/Dashboard/PinterestPost/PinterestPost'));
const PinterestPostForm = lazy(() =>
  import('views/Dashboard/PinterestPost/components/PinterestPostForm')
);
const PinterestGuide = lazy(() => import('views/Dashboard/Guide/PinterestGuide'));
const XAccount = lazy(() => import('views/Dashboard/XAccount/XAccount'));
const XAccountForm = lazy(() => import('views/Dashboard/XAccount/components/XAccountForm'));
const XPost = lazy(() => import('views/Dashboard/XPost/XPost'));
const XPostForm = lazy(() => import('views/Dashboard/XPost/components/XPostForm'));
const InstagramPost = lazy(() => import('views/Dashboard/InstagramPost/InstagramPost'));
const InstagramPostForm = lazy(() =>
  import('views/Dashboard/InstagramPost/components/InstagramPostForm')
);
const TelegramBot = lazy(() => import('views/Dashboard/TelegramBot/TelegramBot'));

var dashRoutes = [
  {
    path: '/dashboard',
    name: 'Thống kê',
    nameKey: 'nav.stats',
    icon: <MdInsertChart color="inherit" />,
    layout: '/admin',
    component: Dashboard,
    role: [Roles.ADMIN, Roles.MANAGER, Roles.USER, Roles.SEO],
  },
  {
    path: '/list',
    name: 'Tài khoản quản trị',
    nameKey: 'nav.adminAccounts',
    icon: <MdPeopleOutline color="inherit" />,
    layout: '/admin',
    component: Admin,
    role: [Roles.ADMIN, Roles.MANAGER],
    groupName: 'VIEW_LIST_ADMIN',
  },
  {
    name: 'Tài khoản mạng xã hội',
    nameKey: 'nav.socialAccounts',
    collapse: 'social-accounts',
    icon: <FaUsers size={20} />,
    views: [
      {
        path: '/facebook/update/:id',
        name: 'Cập nhật tài khoản Facebook',
        nameKey: 'nav.facebookUpdate',
        redirect: true,
        layout: '/admin',
        component: FacebookForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/facebook/create',
        name: 'Tạo tài khoản Facebook',
        nameKey: 'nav.facebookCreate',
        redirect: true,
        layout: '/admin',
        component: FacebookForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      // Drill-down: Tài khoản → Page → Bài viết. Route cụ thể hơn phải đứng
      // TRƯỚC '/facebook' vì Switch match theo prefix (Route không có `exact`).
      {
        path: '/facebook/:accountId/pages/:pageId/posts',
        name: 'Bài viết của Page',
        nameKey: 'nav.pagePosts',
        redirect: true,
        layout: '/admin',
        component: FacebookPagePosts,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/facebook/:accountId/pages',
        name: 'Danh sách Page',
        nameKey: 'nav.pageList',
        redirect: true,
        layout: '/admin',
        component: FacebookPageList,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/facebook',
        name: 'Tài khoản Facebook',
        nameKey: 'nav.facebookAccount',
        icon: <FaFacebook size={20} />,
        layout: '/admin',
        component: FacebookAcount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/messenger',
        name: 'Messenger Inbox',
        nameKey: 'nav.messengerInbox',
        icon: <FaFacebookMessenger size={20} />,
        layout: '/admin',
        component: Messenger,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/instagram/update/:id',
        name: 'Cập nhật tài khoản Instagram',
        nameKey: 'nav.instagramUpdate',
        redirect: true,
        layout: '/admin',
        component: InstagramAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/instagram/create',
        name: 'Tạo tài khoản Instagram',
        nameKey: 'nav.instagramCreate',
        redirect: true,
        layout: '/admin',
        component: InstagramAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/instagram/detail/:id',
        name: 'Chi tiết tài khoản Instagram',
        nameKey: 'nav.instagramDetail',
        redirect: true,
        layout: '/admin',
        component: InstagramAccountDetail,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/instagram',
        name: 'Tài khoản Instagram',
        nameKey: 'nav.instagramAccount',
        icon: <FaInstagram size={20} />,
        layout: '/admin',
        component: InstagramAccount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/youtube/videos/:id',
        name: 'Video kênh YouTube',
        nameKey: 'nav.youtubeVideos',
        redirect: true,
        layout: '/admin',
        component: YoutubeAccountVideos,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/youtube/scheduled-shares/:id?',
        name: 'Lịch chia sẻ YouTube',
        nameKey: 'nav.youtubeScheduledShares',
        redirect: true,
        layout: '/admin',
        component: YoutubeScheduledShares,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/youtube/update/:id',
        name: 'Cập nhật tài khoản YouTube',
        nameKey: 'nav.youtubeUpdate',
        redirect: true,
        layout: '/admin',
        component: YoutubeAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/youtube/create',
        name: 'Tạo tài khoản YouTube',
        nameKey: 'nav.youtubeCreate',
        redirect: true,
        layout: '/admin',
        component: YoutubeAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/youtube',
        name: 'Tài khoản YouTube',
        nameKey: 'nav.youtubeAccount',
        icon: <FaYoutube size={20} />,
        layout: '/admin',
        component: YoutubeAccount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/tiktok/detail/:id',
        name: 'Chi tiết tài khoản Tiktok',
        nameKey: 'nav.tiktokDetail',
        redirect: true,
        layout: '/admin',
        component: TiktokAccountDetail,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/tiktok/videos/:id',
        name: 'Video TikTok của tài khoản',
        nameKey: 'nav.tiktokVideos',
        redirect: true,
        layout: '/admin',
        component: TiktokAccountVideos,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/tiktok/update/:id',
        name: 'Cập nhật tài khoản Tiktok',
        nameKey: 'nav.tiktokUpdate',
        redirect: true,
        layout: '/admin',
        component: TiktokAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_PRODUCT',
      },
      {
        path: '/tiktok/create',
        name: 'Kết nối tài khoản Tiktok',
        nameKey: 'nav.tiktokConnect',
        redirect: true,
        layout: '/admin',
        component: TiktokAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_PRODUCT',
      },
      {
        path: '/tiktok',
        name: 'Tài khoản Tiktok',
        nameKey: 'nav.tiktokAccount',
        icon: <FaTiktok size={20} />,
        layout: '/admin',
        component: TitkokAccount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/pinterest/detail/:id',
        name: 'Chi tiết tài khoản Pinterest',
        nameKey: 'nav.pinterestDetail',
        redirect: true,
        layout: '/admin',
        component: PinterestDetail,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/pinterest/update/:id',
        name: 'Cập nhật tài khoản Pinterest',
        nameKey: 'nav.pinterestUpdate',
        redirect: true,
        layout: '/admin',
        component: PinterestForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/pinterest/create',
        name: 'Tạo tài khoản Pinterest',
        nameKey: 'nav.pinterestCreate',
        redirect: true,
        layout: '/admin',
        component: PinterestForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/pinterest',
        name: 'Tài khoản Pinterest',
        nameKey: 'nav.pinterestAccount',
        icon: <FaPinterest size={20} />,
        layout: '/admin',
        component: PinterestAcount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/x-twiter/update/:id',
        name: 'Cập nhật tài khoản X',
        nameKey: 'nav.xUpdate',
        redirect: true,
        layout: '/admin',
        component: XAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/x-twiter/create',
        name: 'Tạo tài khoản X',
        nameKey: 'nav.xCreate',
        redirect: true,
        layout: '/admin',
        component: XAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/x-twiter',
        name: 'Tài khoản X',
        nameKey: 'nav.xAccount',
        icon: <FaXTwitter size={20} />,
        layout: '/admin',
        component: XAccount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/google/create',
        name: 'Tạo tài khoản Google',
        nameKey: 'nav.googleCreate',
        redirect: true,
        layout: '/admin',
        component: GoogleAccountForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_PRODUCT',
      },
      {
        path: '/google',
        name: 'Tài khoản Google',
        nameKey: 'nav.googleAccount',
        icon: <FaGoogle size={20} />,
        layout: '/admin',
        component: GoogleAcount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/telegraph-account',
        name: 'Tài khoản Telegraph',
        nameKey: 'nav.telegraphAccount',
        icon: <SiTelegraph size={20} />,
        layout: '/admin',
        component: TelegraphAccount,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/threads/update/:id',
        name: 'Cập nhật tài khoản Threads',
        nameKey: 'nav.threadsUpdate',
        redirect: true,
        layout: '/admin',
        component: ThreadsForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/threads/create',
        name: 'Kết nối tài khoản Threads',
        nameKey: 'nav.threadsConnect',
        redirect: true,
        layout: '/admin',
        component: ThreadsForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/threads/detail/:id',
        name: 'Chi tiết tài khoản Threads',
        nameKey: 'nav.threadsDetail',
        redirect: true,
        layout: '/admin',
        component: ThreadsAccountDetail,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/threads/posts/:id',
        name: 'Bài viết của tài khoản Threads',
        nameKey: 'nav.threadsAccountPosts',
        redirect: true,
        layout: '/admin',
        component: ThreadsAccountPosts,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/threads',
        name: 'Tài khoản Threads',
        nameKey: 'nav.threadsAccount',
        icon: <FaThreads size={20} />,
        layout: '/admin',
        component: Threads,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
    ],
  },
  {
    name: 'Nội dung & bài viết',
    nameKey: 'nav.contentPosts',
    collapse: 'posts',
    icon: <BiSolidBookContent size={20} />,
    views: [
      {
        path: '/facebook-post/update/:id',
        name: 'Sửa bài viết Facebook',
        nameKey: 'nav.facebookPostUpdate',
        redirect: true,
        layout: '/admin',
        component: FacebookPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/facebook-post/create',
        name: 'Tạo bài viết Facebook',
        nameKey: 'nav.facebookPostCreate',
        redirect: true,
        layout: '/admin',
        component: FacebookPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/facebook-post',
        redirect: true,
        name: 'Bài viết Facebook',
        nameKey: 'nav.facebookPost',
        icon: <FaRegEdit size={20} />,
        layout: '/admin',
        component: FacebookPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        // Ẩn khỏi sidebar — truy cập bài viết Page qua drill-down Tài khoản → Page.
        // Giữ route làm fallback để link cũ /facebook-page-feed không vỡ.
        path: '/facebook-page-feed',
        name: 'Bài viết của Page',
        nameKey: 'nav.pagePosts',
        redirect: true,
        layout: '/admin',
        component: FacebookPageFeed,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/x-post/update/:id',
        name: 'Sửa bài viết X',
        nameKey: 'nav.xPostUpdate',
        redirect: true,
        layout: '/admin',
        component: XPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/x-post/create',
        name: 'Tạo bài viết X',
        nameKey: 'nav.xPostCreate',
        redirect: true,
        layout: '/admin',
        component: XPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/x-post',
        redirect: true,
        name: 'Bài viết X',
        nameKey: 'nav.xPost',
        icon: <FaXTwitter size={20} />,
        layout: '/admin',
        component: XPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/threads-post/update/:id',
        name: 'Sửa bài viết Threads',
        nameKey: 'nav.threadsPostUpdate',
        redirect: true,
        layout: '/admin',
        component: ThreadsPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/threads-post/create',
        name: 'Tạo bài viết Threads',
        nameKey: 'nav.threadsPostCreate',
        redirect: true,
        layout: '/admin',
        component: ThreadsPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/threads-post',
        redirect: true,
        name: 'Bài viết Threads',
        nameKey: 'nav.threadsPost',
        icon: <FaThreads size={20} />,
        layout: '/admin',
        component: ThreadsPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/comments/detail/:id',
        name: 'Chi tiết comment',
        nameKey: 'nav.commentDetail',
        redirect: true,
        layout: '/admin',
        component: CommentDetail,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/comments/update/:id',
        name: 'Sửa comment',
        nameKey: 'nav.commentUpdate',
        redirect: true,
        layout: '/admin',
        component: CommentForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/comments/create',
        name: 'Tạo comment',
        nameKey: 'nav.commentCreate',
        redirect: true,
        layout: '/admin',
        component: CommentForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/comments/bulk-create',
        name: 'Bulk schedule comment',
        nameKey: 'nav.commentBulk',
        redirect: true,
        layout: '/admin',
        component: CommentsBulk,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/comments',
        name: 'Comment bài viết',
        nameKey: 'nav.comments',
        icon: <MdComment size={20} />,
        layout: '/admin',
        component: Comments,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/comment-templates',
        name: 'Comment templates',
        nameKey: 'nav.commentTemplates',
        icon: <MdLibraryBooks size={20} />,
        layout: '/admin',
        component: CommentTemplates,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/auto-comment-rules',
        name: 'Auto-comment rules',
        nameKey: 'nav.autoCommentRules',
        icon: <MdAutoMode size={20} />,
        layout: '/admin',
        component: AutoCommentRules,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/instagram-post/update/:id',
        name: 'Sửa bài viết Instagram',
        nameKey: 'nav.instagramPostUpdate',
        redirect: true,
        layout: '/admin',
        component: InstagramPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/instagram-post/create',
        name: 'Tạo bài viết Instagram',
        nameKey: 'nav.instagramPostCreate',
        redirect: true,
        layout: '/admin',
        component: InstagramPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/instagram-post',
        redirect: true,
        name: 'Bài viết Instagram',
        nameKey: 'nav.instagramPost',
        icon: <FaInstagram size={20} />,
        layout: '/admin',
        component: InstagramPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/pinterest-post/update/:id',
        name: 'Sửa Pin Pinterest',
        nameKey: 'nav.pinterestPostUpdate',
        redirect: true,
        layout: '/admin',
        component: PinterestPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/pinterest-post/create',
        name: 'Tạo Pin Pinterest',
        nameKey: 'nav.pinterestPostCreate',
        redirect: true,
        layout: '/admin',
        component: PinterestPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/pinterest-post',
        redirect: true,
        name: 'Bài viết Pinterest',
        nameKey: 'nav.pinterestPost',
        icon: <FaPinterest size={20} />,
        layout: '/admin',
        component: PinterestPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/telegraph-post/update/:id',
        name: 'Sửa bài viết Telegraph',
        nameKey: 'nav.telegraphPostUpdate',
        redirect: true,
        layout: '/admin',
        component: TelegraphPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/telegraph-post/create',
        name: 'Tạo bài viết Telegraph',
        nameKey: 'nav.telegraphPostCreate',
        redirect: true,
        layout: '/admin',
        component: TelegraphPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/telegraph-post',
        redirect: true,
        name: 'Bài viết Telegraph',
        nameKey: 'nav.telegraphPost',
        icon: <FaPenNib size={20} />,
        layout: '/admin',
        component: TelegraphPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/tiktok-post/update/:id',
        name: 'Sửa bài viết TikTok',
        nameKey: 'nav.tiktokPostUpdate',
        redirect: true,
        layout: '/admin',
        component: TiktokPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/tiktok-post/create',
        name: 'Tạo bài viết TikTok',
        nameKey: 'nav.tiktokPostCreate',
        redirect: true,
        layout: '/admin',
        component: TiktokPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/tiktok-post',
        redirect: true,
        name: 'Bài viết TikTok',
        nameKey: 'nav.tiktokPost',
        icon: <FaTiktok size={20} />,
        layout: '/admin',
        component: TiktokPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
      {
        path: '/scrapbox-post/update/:id',
        name: 'Sửa bài viết Scrapbox',
        nameKey: 'nav.scrapboxPostUpdate',
        redirect: true,
        layout: '/admin',
        component: ScrapboxPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/scrapbox-post/create',
        name: 'Tạo bài viết Scrapbox',
        nameKey: 'nav.scrapboxPostCreate',
        redirect: true,
        layout: '/admin',
        component: ScrapboxPostForm,
        role: [Roles.ADMIN, Roles.MANAGER],
        groupName: 'UPDATE_MISSION',
      },
      {
        path: '/scrapbox-post',
        name: 'Bài viết Scrapbox',
        nameKey: 'nav.scrapboxPost',
        icon: <SiScrapbox size={20} />,
        layout: '/admin',
        component: ScrapboxPost,
        role: [Roles.ADMIN, Roles.MANAGER],
      },
    ],
  },
  {
    path: '/telegram-bot',
    name: 'Bot Telegram',
    nameKey: 'nav.telegramBot',
    icon: <FaTelegramPlane size={20} />,
    layout: '/admin',
    component: TelegramBot,
    role: [Roles.ADMIN],
  },
  {
    name: 'Hướng dẫn sử dụng',
    nameKey: 'nav.guides',
    collapse: 'guides',
    icon: <MdMenuBook size={20} />,
    views: [
      {
        path: '/guide/pinterest',
        name: 'Đăng Pin Pinterest',
        nameKey: 'nav.guidePinterest',
        icon: <FaPinterest size={20} />,
        layout: '/admin',
        component: PinterestGuide,
        role: [Roles.ADMIN, Roles.MANAGER, Roles.USER, Roles.SEO],
      },
    ],
  },
  {
    // /legal mount ở App.js (public layout, không cần auth). Sidebar entry chỉ
    // dùng NavLink to="/legal" — Admin layout sẽ unmount khi route rời /admin.
    path: '',
    name: 'Trung tâm Pháp lý',
    nameKey: 'nav.legalCenter',
    icon: <FiShield size={18} />,
    layout: '/legal',
    component: null,
    role: [Roles.ADMIN, Roles.MANAGER, Roles.USER, Roles.SEO],
  },
  {
    name: 'TRANG TÀI KHOẢN',
    nameKey: 'nav.accountPages',
    category: 'account',
    rtlName: 'صفحات',
    state: 'pageCollapse',
    views: [
      {
        path: '/profile',
        name: 'Hồ sơ',
        nameKey: 'nav.profile',
        icon: <PersonIcon color="inherit" />,
        secondaryNavbar: true,
        layout: '/admin',
        component: Profile,
        role: [Roles.ADMIN, Roles.MANAGER, Roles.USER, Roles.SEO],
        groupName: 'RESET_PASSWORD_ADMIN',
      },
      {
        path: '/sign-in',
        layout: '/auth',
        redirect: true,
        component: SignIn,
      },
      {
        path: '/sign-up',
        layout: '/auth',
        redirect: true,
        component: SignUp,
      },
    ],
  },
];

export default dashRoutes;
